import { _loadPAComponent, injectStyleScript, _prefetch, _loadDependency } from './loader'
import { shareUtilsGlobal } from "./globalUtils";
import { handleOptionUrl } from './utils/common';
import 'intersection-observer';

import MixinExpose from '@pa/widget-mixins-exposure/lib-umd'

let PAWidgetLoader = {};

// 用于缓存组件实例, KEY=${widgetPath}
export const vueEntryMap = {};
// 用于缓存异步组件
let vueAsyncComMap = {};
// 组件包装
let VuePaWidgetLoader = null;
let VuePaWidgetRender = null;

// 创建加载器VUE组件
function createPaWidgetLoader (Vue) {
  return Vue.extend({
    // functional: true,
    props: {
      options: {
        type: Object,
        default () {
          return {}
        }
      },
      widgets: {
        type: Array,
        default () {
          return []
        }
      }
    },
    render (createElement, context) {
      // 完全透传任何 attribute、事件监听器、子节点等。
      // createElement('div', {props: {}, attrs: {}, on: {}}, [])
      // let widgets = context && context.props.widgets || (this && this.widgets) || [];
      // let pwmOptions = context && context.props.options || (this && this.options) || {};
      let widgets = this.widgets || [];
      if (widgets.length) {
        return createElement('div', {attrs: {'data-widget-wrapper': true}, domProps: this.options.domProps}, widgets.map(widget => createCom(this, createElement, widget)));
      } else {
        return createElement('div', {attrs: {'data-widget-wrapper': true}, domProps: this.options.domProps}, context && context.children);
      }
    }
  });
}
// 创建加载器单个渲染VUE组件
function createPaWidgetRender (Vue) {
  return Vue.extend({
    props: {
      widget: {
        type: Object,
        default () {
          return {}
        }
      },
      page: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    render(createElement, context) {
      let loaderVm = (this.$root.$isPwmRoot ? this.$root :  this.$parent.$loaderVm) || {};
      // 传递widget和page的props
      return createCom(loaderVm, createElement, this.widget, this.page);
    }
  });
}

// 重新包装组件（混入mixins）
function wrapComponent (component, loaderVm) {
  component.components = component.components || {};
  component.components['pa-widget-render'] = component.components['pa-widget-render'] || VuePaWidgetRender;
  component.components['widget-render'] = component.components['widget-render'] || VuePaWidgetRender;
  component.components['pa-widget-loader'] = component.components['pa-widget-loader'] || VuePaWidgetLoader;
  // 注入局部组件pa-widget-render
  component.mixins = component.mixins || [];
  // 曝光埋点 mixins, 包含 props 和 mounted
  component.mixins.push(MixinExpose)
  component.mixins.push({
    beforeCreate () {
      this.$loaderVm = loaderVm;
      this.$loaderVm.shareUtils = shareUtilsGlobal;
    }
  })

  return component;
}
// 递归遍历widget对象，如有widgets则继续递规
function createCom (loaderVm, createElement, widget, page) {
    if (!widget) return null;

    let options = loaderVm.options || {};
    // 转换组件数据
    options.widgetDataRouter = options.widgetDataRouter || function(widget) {
      return widget || {};
    }
    // 转换组件数据
    let widgetData = options.widgetDataRouter(widget);
    // 获取组件widgetPath的值
    let widgetPathValue = widgetData.widgetPath;
    // 如果没有设置widgetPath则不创建组件
    if (!widgetPathValue) return null;

    // 如果缓存对象中不存在，则创建
    if (!vueAsyncComMap[widgetPathValue]) {
      vueAsyncComMap[widgetPathValue] = createAsyncComponent(loaderVm, widgetData, widgetPathValue);  
    }
    // 从缓存对象中取出组件
    let com = vueAsyncComMap[widgetPathValue];
    
    // 设置内置DOM属性
    widgetData.attrs = widgetData.attrs || {};
    widgetData.attrs['data-widget-component'] = widgetPathValue;

    // 设置内置Props属性
    widgetData.props = widgetData.props || {};
    // 继承父级的page
    widgetData.props.page = Object.assign(widgetData.props.page || {}, page);
    

    // 遍历子组件
    let children = null, childField = options.childField || 'widgets';
    if (widget[childField] && widget[childField].length) {
        children = widget[childField].map(widget => {
            return createCom(loaderVm, createElement, widget);        
        })
    }
    // 创建VNODE
    return createElement(com, {
      attrs: widgetData.attrs,
      props: widgetData.props,
      on: widgetData.on,
      slot: widgetData.slot,
      scopedSlots: widgetData.scopedSlots,
      class: widgetData.class,
      style: widgetData.style,
      domProps: widgetData.style,
      nativeOn: widgetData.nativeOn,
      directives: widgetData.directives,
      key: widgetData.key,
      ref: widgetData.ref,
      refInFor: widgetData.refInFor
    }, children);
}
// 创建异步VUE组件
function createAsyncComponent (loaderVm, widget, widgetPathValue) {
  let options = loaderVm.options || {};
  // 如果有设置自定义组件则使用自定义组件
  if (widget.customComponent) {
    return widget.customComponent;
  }
  let opts = handleOptionUrl({...options, widgetPath: widgetPathValue, widget: widget});
  // 声明组件
  return () => {
    return {
      // 需要加载的组件 (应该是一个 `Promise` 对象)
      component: new Promise((resolve, reject) => {
        
        // 查找缓存对象中是否存在
        if (vueEntryMap[widgetPathValue]){
          resolve(vueEntryMap[widgetPathValue]);
        }
        // 请求远程组件
        else {
          injectStyleScript(opts).then(async (scriptExport) => {
              if (scriptExport) {
                  if (scriptExport?.depends) {
                      await Promise.all(_loadDependency(scriptExport?.depends, options));
                  }
                  vueEntryMap[widgetPathValue] = wrapComponent(scriptExport.default, loaderVm);
                  // 返回组件
                  resolve(vueEntryMap[widgetPathValue]);
              } else {
                  reject();
              }
          }).catch(e => {
            reject(e);
          })
        }
      }),
      // 异步组件加载时使用的组件
      loading: widget.loading || options.loading,// Vue.extend({ template: '<div class="pwm-widget-loader-loading">组件加载中...</div>' }),
      // 加载失败时使用的组件
      error: widget.error || options.error, // Vue.extend({ template: '<div class="pwm-widget-loader-loading">组件加载失败</div>' }),
      // 展示加载时组件的延时时间。默认值是 0 (毫秒)
      delay: widget.delay || options.delay || 0,
      // 如果提供了超时时间且组件加载也超时了，
      // 则使用加载失败时使用的组件。默认值是：`3000` (毫秒)
      timeout: widget.timeout || options.timeout || 3000
    }
  };
}

PAWidgetLoader.loadPAComponent = _loadPAComponent;

/*
 新加载组件API
 @param options {Object} 参数
            el {String<DocuemntSelectorString>/HTMLElement}  - 必选，挂载的元素
            offline {Boolean}  - 可选，是否离线页面（即HTML为file://协议），默认为false
            fetchType {String}  - 可选，请求方式，可选值为ajaxRequest时则使用原生AJAX发请求，默认使用aladdin.http.request
            widgets    {Array<Object>}  - 必选，组件数据
                widgetPath {String} - 可选，组件索引（格式：名称空间/组件英文名称/组件版本号）
                props    {Object} - 可选，组件props，指传入组件的props属性对象
                attrs    {Object} - 可选，组件attrs，指绑定在组件包层DOM元素上的属性
                slot     {String} - 可选，组件插槽名称，可将当前组件以插槽的形式插入到容器组件内部，可选项
                on       {Object} - 可选，传入组件内的事件对象，可在组件内部使用$emit触发
                loading    {VueComponent} - 可选，异步组件加载时使用的组件
                error    {VueComponent} - 可选，加载失败时使用的组件
                delay    {Number} - 可选，展示加载时组件的延时时间(单位：毫秒)。默认值是 0
                timeout  {Number} - 可选，组件加载超时时间(单位：毫秒)。如果提供了超时时间且组件加载也超时了，则使用加载失败时使用的组件。默认值是： 3000
            baseOrigin {String}   - 可选，组件资源主域名，可选项，默认由加载器指定（除本地调试外不建议修改）
            childField {String}   - 可选，子组件集合KEY，默认值：widgets
            widgetDataRouter {Function} - 可选，用于转换传递给组件的数据结构，接收入参（widget），需要返回组件数据（如：props、attrs、slot、on、loading、error、delay、timeout等属性对象）
            scriptContentRouter {Function} - 可选，用于转换组件JS内容，接收入参（scriptContent, url, opts），需要返回scriptContent
            styleContentRouter {Function} - 可选，用于转换组件CSS内容，接收入参（styleContent, url, opts），需要返回scriptContent
            scriptUrlRouter {Function} - 可选，用于转换组件JS资源路径，接收入参（widgetPath, url, opts），需要返回url
            styleUrlRouter {Function} - 可选，用于转换组件CSS资源路径，接收入参（widgetPath, url, opts），需要返回url
            exportScriptModule {Function} - 可选，用于自定义导出JS模块，接收入参（scriptContent, url, opts），需要返回包含default的导出对象或者false(使用内置导出方法)
            loading    {VueComponent} - 可选，异步组件加载时使用的组件（会应用在所有加载组件）
            error    {VueComponent} - 可选，加载失败时使用的组件（会应用在所有加载组件）
            delay    {Number} - 可选，展示加载时组件的延时时间(单位：毫秒)。默认值是 0（会应用在所有加载组件）
            timeout  {Number} - 可选，组件加载超时时间(单位：毫秒)（会应用在所有加载组件）如果提供了超时时间且组件加载也超时了，则使用加载失败时使用的组件。默认值是： 3000
 @return <VueInstance> 返回组件实例
 */

PAWidgetLoader.loadPwmComponent = function (options) {    
    if (VuePaWidgetLoader === null) {
      VuePaWidgetLoader = createPaWidgetLoader(window.Vue);
    }
    if (VuePaWidgetRender === null) {
      VuePaWidgetRender = createPaWidgetRender(window.Vue);
    }
    if (options.widgets) {
      let vm = new VuePaWidgetLoader({
        // components: {
        //   'poppy-ui-button': Vue.extend({template: '<div>poppy-ui-button</div>'})
        // }
      });
      vm.$isPwmRoot = true;
      vm.$props.options = options;      
      vm.$props.widgets = options.widgets;
      delete vm.$props.options.widgets;
      vm.$mount(options.el);
      return vm;
    }
    
    return null;
};
/**
* 预加载
@param options {Object} 参数对象
          baseOrigin {String}   - 可选，组件资源主域名，可选项，默认由加载器指定（除本地调试外不建议修改）
          offline {Boolean}   - 可选，是否离线页面，默认false
          fetchType {String}  - 可选, 'elementLoad'/'ajaxLoad'
          widgetNames {Array<String>} - 可选，需要预加载的组件（会先下载组件资源后再开始渲染）
          depends {Object}  - 可选
@example: PAWidgetLoader.prefetch({
            baseOrigin: 'http://localhost:9000'
            widgetNames: ['platform/introduce-ol/1.0.0']，
            depends: {
              shareUtils: {
                'pwm-common-login': 'http://localhost:8080/widget/common/login/render/index.js',
                'pwm-aum-request': 'http://localhost:8080/widget/aum/request/render/index.js'
              },
              shareLibs: {
                'flexible': 'http://localhost:8080/lib/flexible.js'
              },
              shareStyles: {
                'pwm-aum-style': 'http://localhost:8080/widget/aum/style/render/index.css'
              }
            }
            })
@return <Promise>
          
*/
PAWidgetLoader.prefetch = _prefetch;


PAWidgetLoader.install = (Vue) => {
  if (VuePaWidgetLoader === null) {
    VuePaWidgetLoader = createPaWidgetLoader(Vue);
  }
  if (VuePaWidgetRender === null) {
    VuePaWidgetRender = createPaWidgetRender(Vue);
  }
  // 注册全局组件pa-widget-loader
  Vue.component('pa-widget-loader', VuePaWidgetLoader);
  Vue.component('pa-widget-render', VuePaWidgetRender);
}

export default PAWidgetLoader;